
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaPause as ObiMediaPauseElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-pause.js';
 
 
 

 
 export const ObiMediaPause = createComponent({
   react: React,
   tagName: 'obi-media-pause',
   elementClass: ObiMediaPauseElement,
   events: {
     
   }
  });
 
 